import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/modules/dropdown.less';
import 'semantic-ui-less/definitions/modules/transition.less';

export default Dropdown;
